import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  layout: {
    base: {
      display: 'flex',
      marginBottom: theme.settings.spacing.xLarge,
      marginLeft: `-${theme.settings.spacing.large}`,
    },

    main: {
      minHeight: '100vh',
      flexDirection: 'column',
    },

    fill: {
      flex: 1,
    },

    flush: {
      marginBottom: 0,
    },
  },

  item: {
    base: {
      display: 'flex',
      flex: 0,
      paddingLeft: theme.settings.spacing.large,
    },

    fill: {
      flex: 1,
    },

    collapse: {
      flex: 0,
    },

    centerContent: {
      alignItems: 'center',
    },

    flush: {
      paddingLeft: 0,
    },
  },
})
